// Services
import './services/auth';
import './services/api';
import './services/access-guard';
import './services/consent';
import { pwaInstallService } from './services/pwa-install';
import './services/trial-notice';
import { i18nService } from './services/i18n';

// Components
import './components/shell/rc-app';
import './components/shell/rc-app-ad';
import './components/auth/rc-auth-status';
import './components/auth/rc-login';
import './components/shell/rc-language-switcher';
import './components/shell/rc-notification-menu';
import './components/shell/rc-user-menu';
import './components/dashboard/rc-dashboard';
import './components/calendar/rc-calendar';
import './components/property/rc-property-list';
import './components/property/rc-property-details';
import './components/property/rc-property-detail-page';
import './components/damage-reports/rc-damage-report-list-page';
import './components/tenant/rc-tenant-list';
import './components/timeline/rc-timeline-events';
import './components/document/rc-document-list';
import './components/reminder/rc-reminder-list';
import './components/shared/rc-confirm-dialog';
import './components/candidate/rc-candidate-list';
import './components/onboarding/rc-onboarding-wizard';
import './components/contract-timeline/rc-contract-timeline';
import './components/profile/rc-profile';
import './components/tenant-portal/rc-tenant-portal-page';
import './components/shared/rc-toast-stack';
import './components/admin/rc-admin';
import './components/help/rc-help';
import './components/shared/rc-rich-text-editor';
import './components/shared/rc-consent-banner';
import './components/survey/rc-survey';
import './components/welcome/rc-tenant-welcome-page';
import './components/property/rc-public-property-page';
import './components/tenant-portal/rc-tenant-invite-page';
import './components/contractor/rc-contractor-list';
import './pages/pricing';

i18nService.init();
pwaInstallService.init();
